import React from "react";
import { Box, Typography } from "@vp/swan";
import { useProductOptionsTranslations } from "../../../../../product-options-translations/product-option-translations";
export const ListboxPlaceholder = () => {
    const { i18n } = useProductOptionsTranslations();
    return (React.createElement(Box, null,
        React.createElement(Typography, { fontWeight: "bold" }, i18n("select"))));
};
//# sourceMappingURL=listbox-placeholder.js.map